/* eslint-disable */

import { Space, Typography } from 'antd';
import { ProjectId, CompanyType, User } from 'api/models';
import { Project } from 'api/project';
import { NativeUserInvitation } from 'components/organisms/project-invitations';
import { ExternalUserInvitation } from 'components/organisms/project-invitations/external-user';
import { useMembersByCompanies } from 'data/members/hooks/use-member-by-companies';
import { useStoreMembers } from 'data/members/hooks/use-store-members';
import { useProjectDetail } from 'data/projects';
import { useMemberships } from 'hooks/use-memberships';
import { useUser } from 'hooks/use-user';
import React, { useState } from 'react';
import { Memberships } from 'stores/memberships';
import useDeepCompareEffect from 'use-deep-compare-effect';

export const DemoUserInvitations = () => {
  const loggedInUser = useUser();
  const loggedUserCompnayId = loggedInUser.company.companyId;
  const [, memberships = Memberships.empty()] = useMemberships(ProjectId(912));
  const { data: project } = useProjectDetail(ProjectId(912));
  const customer = {
    companyId: 330,
    companyName: 'MnM',
    capacity: 40,
    companyType: CompanyType.Customer,
  };
  const membersStoreData = useStoreMembers();
  const [allMembers, setAllMembersList] = useState<{
    nativeUsersList: User[];
    externalUsersList: User[];
  }>({ nativeUsersList: [], externalUsersList: [] });
  const {
    [loggedUserCompnayId]: nativeUsersList = [],
    [330]: externalUsersList = [],
  } = useMembersByCompanies([loggedUserCompnayId, 330]);

  useDeepCompareEffect(() => {
    setAllMembersList({ nativeUsersList, externalUsersList });
  }, [nativeUsersList, externalUsersList]);

  const { Text, Title } = Typography;

  return (
    <>
      <Space direction="vertical" size="large">
        <Title level={4}>Native user invitation</Title>
        <Text strong> for project id: 912, native company: 2</Text>

        <Text code>
          allMembers: User[];
          <br />
          memberships: number[];
          <br />
          projectId: number;
          <br />
          userType?: UserType;
          <br />
          buttonText: string | JSX.Element;
          <br />
          form?: FormInstance;// if you want validations or use it part of a
          form <br />
          autoFocus?: boolean;
          <br />
        </Text>

        <NativeUserInvitation
          allOptions={allMembers.nativeUsersList}
          inValidOptions={memberships.users}
          projectId={912}
          buttonText="hello"
          project={project as Project}
        />
      </Space>

      <Space direction="vertical" size="large">
        <Title level={4}>External user invitation</Title>
        <Text underline>
          {' '}
          This first creates the user and adds them to project
        </Text>
        <Text strong> for project id: 912, External company: 330</Text>

        <Text code>
          allMembers: User[];
          <br />
          memberships: number[];
          <br />
          projectId: number;
          <br />
          userType?: UserType;
          <br />
          buttonText: string | JSX.Element;
          <br />
          form?: FormInstance;// if you want validations or use it part of a
          form <br />
          autoFocus?: boolean;
          <br />
        </Text>

        <ExternalUserInvitation
          allOptions={allMembers.externalUsersList}
          inValidOptions={memberships.users}
          projectId={912}
          buttonText="hello"
          company={customer}
        />
      </Space>
    </>
  );
};
